import ClearCache from './ClearCache';

export default ClearCache;